<template>
  <div class="xingyongfengxian-layer">
    <caseheader></caseheader>
    <div class="xyfx-container">
      <!-- 内容区域 -->
      <div class="xyfx-content">
        <component :is="currentStep" @nextStep="nextStep" />
      </div>
    </div>
  </div>
</template>

<script>
import Caseheader from '@/components/layout/caseheader.vue'
import Gerenyushouruxinxi from '@/views/case/xinyongfengxian/gerenyushouruxinxi.vue'
import Daikuanxinxi from '@/views/case/xinyongfengxian/daikuanxinxi.vue'
import Monigerenzhengxinbaogao from '@/views/case/xinyongfengxian/monigerenzhengxinbaogao.vue'
import Fenxijieguo from '@/views/case/xinyongfengxian/fenxijieguo.vue'

export default {
  name: '',
  components: {
    Caseheader,
    Gerenyushouruxinxi,
    Daikuanxinxi,
    Monigerenzhengxinbaogao,
    Fenxijieguo
  },
  props: {},
  data () {
    return {
      currentStep: 'Gerenyushouruxinxi'
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () {
    // 判断地址栏中是否有type和caseno参数,有的话就是从fastgpt返回，直接跳到报告步骤
    let route = this.$router.path.query
    if (route.type && route.caseno) {
      this.currentStep = 'Monigerenzhengxinbaogao'
    }
   },
  methods: {
    nextStep (step) {
      this.currentStep = step
    }
  }
}
</script>

<style scoped lang="less">
.xingyongfengxian-layer {
  height: 100%;

  .xyfx-container {
    padding: 20px;
    display: flex;
    gap: 20px;
    height: calc(100% - 100px);
    width: calc(100% - 40px);

    .xyfx-content {
      flex: 1;
      background: rgba(5, 5, 5, 0.68);
      border-radius: 25px;
      color: #fff;
      padding: 30px;
      height: calc(100% - 60px);
    }
  }
}
</style>
